import Breadcrumb from "Components/UI/Breadcrumb";
import Spinners from "Components/UI/Spinner";
import PaginatedTable from "Components/Tables/PaginatedTable";
import React, { useEffect, useState } from "react";
import { Card, CardBody, Container } from "reactstrap";
import useTableFilters from "helpers/hooks/useTableFilters";
import { generateQueryParams } from "helpers/queryParams";
import { Link } from "react-router-dom";
import convertDateFormat from "Components/Date/DateFormat";
import DeleteModal from "Components/Modals/DeleteModal";
import { deleteDiscount, getDiscounts } from "helpers/API Calls/Operations/discounts";

const head = [
  { id: 1, name: "#", isSortable: true, key: "id" },
  { id: 2, name: "Name", isSortable: true, key: "name" },
  { id: 3, name: "Code", isSortable: true, key: "code" },
  { id: 4, name: "Type", isSortable: true, key: "discount_type_id" },
  { id: 5, name: "Validity", isSortable: true, key: "discount_validity_id" },
  { id: 6, name: "Applied", isSortable: true, key: "discount_scope_id" },
  { id: 8, name: "Used", isSortable: true, key: "used_frequency" },
  { id: 7, name: "Status", isSortable: true, key: "status" },
  {id: 9, name: "Created", isSortable: true, key: "created_at"},
  {id: 10,name: "Updated", isSortable: true, key: "updated_at"},
  { id: 11, name: "Actions", isSortable: false, },
]

function Discounts() {

  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [data, setData] = useState<any[]>([]);
  const [pagination, setPagination] = useState<any>({current_page: 1, last_page: 1, per_page: 10, total: 0});

  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  const [selectedItem, setSelectedItem] = useState<any>(null);
  
  const { filters, updateFilter } = useTableFilters();

  const fetchData = async () => {
    setIsLoading(true);
    const response = await getDiscounts(generateQueryParams(filters));
    if (response.success) {
      setData(response.data.items);
      setPagination(response.data.pagination);
    }
    setIsLoading(false);
  }

  useEffect(() => {
    fetchData();
  }, [filters]);

  const handleDeleteClick = (item) => {
    setSelectedItem(item);
    setDeleteModal(true);
  };

  const handleDeleteConfirm = async () => {
    if (selectedItem) {
      const response = await deleteDiscount(selectedItem.id);
      if (response.success) {
        setDeleteModal(false);
        setSelectedItem(null);
        fetchData();
      }
    }
  };

  const onCloseClick = () => {
    setDeleteModal(false);
    setSelectedItem(null);
  };


  return (
    <>
    <div className="page-content">
      <Container fluid>
        <Breadcrumb items={[{ label: "Discount Codes"},]} />
        {isLoading ? <div className="position-relative vh-100"><Spinners/></div>
        :
        <Card>
          <CardBody>
            <PaginatedTable
              tableHead={head}
              pagination={pagination}
              isAddButton={true}
              buttonText="Add New Code"
              to="/discounts/create"
              updateFilter={updateFilter}
              filters={filters}
            > 
              {data.length > 0 && data.map((item) => (
                  <tr key={item?.id}>
                    <td>{item?.id}</td>
                    <td>{item?.name}</td>
                    <td>{item?.code}</td>
                    <td>{item?.discount_type?.discount_type}</td>
                    <td>{item?.discount_validity?.discount_validity}</td>
                    <td>{item?.discount_scope?.discount_scope}</td>
                    <td>{item?.used_frequency}</td>
                    <td>
                      <span className={`badge badge-soft-${item.status === 'active' ? 'success' : 'danger'}`}>
                        {item?.status?.charAt(0).toUpperCase() + item?.status?.slice(1)}
                      </span>
                    </td>
                    <td>{convertDateFormat(item.created_at)}</td>
                    <td>{convertDateFormat(item.updated_at)}</td>
                    <td>
                      <div>
                        <Link to={`${item.id}/edit`} className="btn btn-primary btn-sm mx-1"><i className="bx bx-pencil"/></Link>
                        <button className="btn btn-danger btn-sm" onClick={() => handleDeleteClick(item)}><i className="mdi mdi-trash-can-outline"></i></button>
                      </div>
                    </td>
                  </tr>))
                }
                {!isLoading && data.length === 0 && <tr className="text-center"><td colSpan={head.length} className="text-danger">No Data Found</td></tr>}
                
            </PaginatedTable>
          </CardBody>
        </Card>}
      </Container>
    </div>
    {deleteModal && <DeleteModal
      show={deleteModal}
      onDeleteClick={handleDeleteConfirm}
      onCloseClick={onCloseClick}
      message={`${selectedItem?.name} code?`}
    />}
    
    </>
  )
}

export default Discounts
